import { clearFields } from 'redux-form';
import {
    mapResourceAssignmentFormValuesToResourceUpdateParameters,
    ASSIGNEE_PROFILE_ID_NAME,
    RESOURCE_IDS_NAME,
} from '@mews-commander/resources';
import { createAsyncActionTypes } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import { prefix } from './module';

export const RESOURCE_UPDATE = prefix('RESOURCE_UPDATE');
export const [RESOURCE_UPDATE_STARTED, RESOURCE_UPDATE_SUCCEEDED, RESOURCE_UPDATE_FAILED] =
    createAsyncActionTypes(RESOURCE_UPDATE);

export const RESOURCE_ASSIGNMENT_FORM_INIT = prefix('RESOURCE_ASSIGNMENT_FORM_INIT');
export const [
    RESOURCE_ASSIGNMENT_FORM_INIT_SUCCEEDED,
    RESOURCE_ASSIGNMENT_FORM_INIT_STARTED,
    RESOURCE_ASSIGNMENT_FORM_INIT_FAILED,
] = createAsyncActionTypes(RESOURCE_ASSIGNMENT_FORM_INIT);

export const createResourceAssignment =
    ({ assigneeProfileId, resourceIds }: $TSFixMe, { enterpriseId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const resourceUpdates = mapResourceAssignmentFormValuesToResourceUpdateParameters({
            assigneeProfileId,
            resourceIds,
        });

        const promise = container().resourceComponent.update({ enterpriseId, resourceUpdates });
        return dispatch(createFetchAction(RESOURCE_UPDATE, promise));
    };

export const resetResourceAssignmentForm = (form: $TSFixMe) =>
    clearFields(form, false, false, ASSIGNEE_PROFILE_ID_NAME, RESOURCE_IDS_NAME);
